import { mapToPeriodDictionary, mapToTypeDictionary } from "./schema-dictionary"


export const mapActiveToPriceDataKeyDictionary = (period, type) => {
    console.log("[ENTERING STEP 3 - NEP TECHNIQUE - ORCHESTRATION BY ASSEMBLER]: Projection Step")
    console.log(`${"=".repeat(30)}`)  
    
    //Key 1 - change key: controls +/- amount and %/$ label
    const changeKeyPrefix = mapToPeriodDictionary(period)
    const changeKeySuffix = mapToTypeDictionary(type)
    const change          = changeKeyPrefix + changeKeySuffix
    
    // Key 2 - heat key: controls coloring of grid cell
    const heatKeyPrefix = mapToPeriodDictionary(period)
    const heatKeySuffix = 'Heat' 
    const heat          = heatKeyPrefix + heatKeySuffix

    // Key 3 - shading key: controls the shade of the grid cell's heat color (shade of red / green) via a new prop the backend hangs on the prices DTO - that props value is driven by the period's % change (just like how the heat value if driven by the periods % change), so the %/$ toggle only swaps the label and never re-shades the grid
    const shadingKeyPrefix = mapToPeriodDictionary(period)
    const shadingKeySuffix = 'Shading'
    const shading          = shadingKeyPrefix + shadingKeySuffix
        
    // Fully Assembled Active Keys Projected - For Component to Consume
    console.log("[ACTIVE / CHARTED CHANGE, HEAT AND SHADING FIELDS ASSEMBLED FROM DICTIONARY]:")
    console.log({ change, heat, shading })
    console.log(`${"=".repeat(60)}`)  
    
    return {
        change,     // EX  oneDayPercentChange
        heat,       // EX: oneDayHeat
        shading     // EX: oneDayShading
    }
}

export const projectToBarLayoutSchema = (barLayoutValues) => {
    console.log("[ENTERING STEP 3 - NEP TECHNIQUE - ORCHESTRATION BY ASSEMBLER]: Projection Step")
    console.log(`${"=".repeat(30)}`)

    // Fully Assembled Bar Layout Projected - For Component to Consume
    console.log("[BAR LAYOUT BAR GUTTER / PLACEMENTS PROJECTED]:")
    console.log(barLayoutValues)
    console.log(`${"=".repeat(60)}`)

    return {
        barGutter:  barLayoutValues.barGutter,
        placements: barLayoutValues.placements
    }
}